export const EDITOR_WORD_LIMIT = 2500

export const NOT_READY = 'Not ready'
export const NEEDS_TWEAKS = 'Needs tweaks'
export const ALL_SET = 'All set!'

export const WRITING_GIF_HEIGHT = 250
export const WRITING_GIF_WIDTH = 250
export const DEBOUNCE_SAVE_PAPER_TIME_PERIOD = 2000
export const DEBOUNCE_MANUAL_EDIT_TIME_PERIOD = 2000
export const WORDS = 'words'
export const UNTITLED = 'Untitled'
export const REVIEW = 'Review'
export const DISCLAIMER_TEXT = `This AI-powered tool offers writing enhancement suggestions, but may not be perfect or suitable for all contexts. Please review output carefully. Built with Meta Llama 3 and governed by Chegg’s `
export enum FeedbackTab {
  NO_ACTIVE_TAB = -1,
  GRAMMAR_TAB = 0,
  PARAPHRASE_TAB = 1,
}

// timeout in milliseconds
export const FULL_CHECK_TIMEOUT = 180000
export const SELECTION_CHECK_TIMEOUT = 60000

export const QA_WORD_COUNT_LIMIT = 4 // synonym & rewrite word count limit

export const SENTENCE_FETCH_RETRY_COUNT = 2
export const SYNONYM_REWRITE_FETCH_RETRY_COUNT = 2
